import { useNavigate, useLocation } from "react-router-dom";
import { accessTokens } from "./accessTokens";
import { useClientConnectorSetup } from "./useClientConnectorSetup";

/**
 * Страница для тестирования clientConnector без загрузки Unity.
 * clientConnector доступен в консоли (window.clientConnector).
 */
const ClientConnectorTestPage = () => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(useLocation().search);
  const tokenIndex = searchParams.get("token");
  const accessToken = tokenIndex
    ? accessTokens[parseInt(tokenIndex, 10)] ?? accessTokens[0]
    : accessTokens[0];

  useClientConnectorSetup(accessToken);

  return (
    <div
      style={{
        padding: "24px",
        fontFamily: "system-ui, sans-serif",
        maxWidth: "600px",
        margin: "0 auto",
      }}
    >
      <h1>Тест clientConnector (без Unity)</h1>
      <p>
        <code>window.clientConnector</code> доступен в консоли браузера.
      </p>
      <p style={{ fontSize: "14px", color: "#666" }}>
        Пример: <code>clientConnector.room.find(&#123;gameType: 'pvp1vs1', bet: 50&#125;)</code>
      </p>
      <button
        style={{
          padding: "12px 16px",
          backgroundColor: "#4CAF50",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
        onClick={() => navigate("/main")}
      >
        ← Вернуться
      </button>
    </div>
  );
};

export default ClientConnectorTestPage;
